/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import type {
  FixedSizeCodec,
  FixedSizeDecoder,
  FixedSizeEncoder,
} from "@solana/kit";
import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU8Decoder,
  getU8Encoder,
} from "@solana/kit";

export interface WhirlpoolBumps {
  whirlpoolBump: number;
}

export type WhirlpoolBumpsArgs = WhirlpoolBumps;

export function getWhirlpoolBumpsEncoder(): FixedSizeEncoder<WhirlpoolBumpsArgs> {
  return getStructEncoder([["whirlpoolBump", getU8Encoder()]]);
}

export function getWhirlpoolBumpsDecoder(): FixedSizeDecoder<WhirlpoolBumps> {
  return getStructDecoder([["whirlpoolBump", getU8Decoder()]]);
}

export function getWhirlpoolBumpsCodec(): FixedSizeCodec<
  WhirlpoolBumpsArgs,
  WhirlpoolBumps
> {
  return combineCodec(getWhirlpoolBumpsEncoder(), getWhirlpoolBumpsDecoder());
}
